const sideDescriptionDuration =[
        
    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {label: "Description",
    controlType:"text area",
    options:[]
    },

    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]

export default sideDescriptionDuration
